import {
    DataFlowDatasetSettings,
    DatasetFormatType
} from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { IViolation, Metamodel, sanitizeAndFormatString } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { IntegerDataFlowType, StringDataFlowType } from '../dataflow-datatype';
import { DataFlowSource } from '../dataflow-source';

@Metamodel.model({
    name: adfModelTypeMap.salesforceV2.dataflowSettings,
    validator: SalesforceSettings.validateSettings
})
export class SalesforceSettings extends DataFlowDatasetSettings {
    public static validateSettings(settings: SalesforceSettings): IViolation[] {
        const violations: IViolation[] = [];
        if (settings.transform instanceof DataFlowSource) {
            if (!settings.objectApiName.expression && !settings.objectApiName.parameterized) {
                violations.push({
                    context: settings.objectApiName,
                    message: () => sanitizeAndFormatString(stringResources.RequiredTemplate, stringResources.TableNameDisplay_ObjectApiName)
                });
            }
            if (settings.maxRecords.expression != null && !settings.maxRecords.parameterized && parseInt(settings.maxRecords.expression, 10) < 1) {
                violations.push({
                    context: settings.maxRecords,
                    message: () => stringResources.MaxRecords_ValidatorMinErr
                });
            }
        }
        return violations.length > 0 ? violations : undefined;
    }

    @Metamodel.attribute({
    })
    public objectApiName: DataFlowExpression;

    @Metamodel.attribute({
    })
    public maxRecords: DataFlowExpression;

    public getDatasetType(): string {
        // for now, Salesforce only support inline mode, it does not have dataset
        return undefined;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Salesforce;
    }

    public getIconClass(): string {
        return 'svg-i-100x100-Salesforce';
    }

    public getSubFormat(): string {
        return undefined;
    }

    public initialize(subFormat: string): void {
        this.objectApiName = this.transform.createTemplatableExpression(StringDataFlowType.TYPE);
        this.maxRecords = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
    }
}
